import React from 'react'
import { GoogleLogin } from '@react-oauth/google'
import axios from "axios";
import { host } from './script/variables';

const Login = ({ setIsLogin }) => {
  const login = async (credential) => {
    try {
      const resp = await axios.post(`${host}/user/login`, { credential });
      if (resp.status === 200) {
        const token1 = resp.headers.authorization;
        localStorage.setItem('token', token1);
        console.log('login response is ',resp.data.data.user)
        localStorage.setItem('cafeuser', JSON.stringify(resp.data.data.user)); // <-- was missing
        localStorage.setItem("providerlogintime", new Date().getTime());
        setIsLogin(true);
      }
    } catch (error) {
      console.log("Login error", error);
    }
  };

  const onSuccess = (credentialResponse) => {
    login(credentialResponse.credential);
  };

  const onFailure = () => {
    console.log("Google login failed");
  };

  return (
    <div id='signInButton'>
      <GoogleLogin
        onSuccess={onSuccess}
        onError={onFailure}
        useOneTap={false}
        text="signin"
      />
    </div>
  )
}

export default Login